import { cn } from '@/lib/cn';
import type { FC } from 'react';

/**
 * A horizontal dividing line.
 */
export const Divider: FC<{ className?: string }> = ({ className }) => {
    return <hr className={cn('w-full border-dividerPrimary', className)} />;
};
